export default __webpack_public_path__ + "static/media/bakun_municipal_seal.fb2c1f81.png";